import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contextos/AuthContext';
import { Carregando } from '../componentes/Estados';
import { SemAutorizacao } from '../componentes/SemAutorizacao';

/**
 * Esconder rota é conveniência de navegação, não segurança.
 * Quem manda é a regra do Firestore: mesmo alterando a página no navegador,
 * a escrita é recusada no servidor.
 */
export function GuardaAutenticado() {
  const { estado } = useAuth();
  const local = useLocation();

  if (estado === 'CARREGANDO') return <Carregando />;
  if (estado === 'DESLOGADO') return <Navigate to="/entrar" state={{ de: local.pathname }} replace />;
  if (estado !== 'LIBERADO') return <SemAutorizacao motivo={estado} />;
  return <Outlet />;
}

export function GuardaAdministrador() {
  const { ehAdministrador } = useAuth();
  return ehAdministrador ? <Outlet /> : <Navigate to="/" replace />;
}
